import builder from '../builder';
import Check1 from '../../streamline-icons/bold/check-1.svg';

export default builder('IconCheck1Bold', Check1);
